var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgLogoIconGradient = function SvgLogoIconGradient(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 98,
    viewBox: "0 0 105 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.32 0H103.8L55.94 36.59H0.409973L48.32 0Z",
    fill: "url(#paint0_radial_2_6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.11 38.44V97.56L87.12 76.67V17.14L59.11 38.44Z",
    fill: "url(#paint1_radial_2_6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.63 14.41L104.59 3.89001L104.6 20.06L90.63 30.61V14.41Z",
    fill: "url(#paint2_radial_2_6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.63 34.96L104.6 24.45V41.23L90.63 51.77V34.96Z",
    fill: "url(#paint3_radial_2_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.73 17.42) scale(80.06)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23213.9 1411.62) scale(2249.2 6457.73)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11642.8 467.215) scale(1118.16 2138.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11641.4 499.272) scale(1122.49 2195.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgLogoIconGradient);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-ui/components/LogoIcon/svgs/LogoIconGradient.3b08bec85e96d47943e997913defaad3.svg";